import AnalyticsClient from './client';
import events from './events';

export default new AnalyticsClient();
export { events };
